import { Button, Menu, MenuProps, Popover, Typography, message } from 'antd'
import { QRCodeSVG } from 'qrcode.react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import agentMenus from '~/config/agentMenus'
import menus from '~/config/menus'
import { REF_CODE } from '~/constants/storage'
import { isAdmin, logoutStorage } from '~/utils/auth'
import { svgToPng } from '~/utils/img'

import { Container } from './style'

const Index = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [nextMenu, setNextMenu] = useState<typeof menus>([])

  useEffect(() => {
    if (isAdmin()) {
      setNextMenu(menus)
    } else {
      setNextMenu(agentMenus)
    }
  }, [])

  const onSelect = useCallback<Required<MenuProps>['onClick']>(
    (menuInfo) => {
      navigate(menuInfo.key)
    },
    [navigate],
  )

  const [selectedKeys, setSelectedKeys] = useState<string[]>(['overview'])

  useEffect(() => {
    setSelectedKeys([location.pathname])
  }, [location])

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([])

  const isFirst = useRef(true)
  if (isFirst.current) {
    isFirst.current = false
    menus.forEach((menu) => {
      if (menu.children && menu.children?.length > 0) {
        menu.children.forEach((child) => {
          if (child.key === location.pathname) {
            setDefaultOpenKeys([menu.key])
          }
        })
      }
    })
  }
  const logout = useCallback(() => {
    logoutStorage()
    navigate('/login')
  }, [navigate])

  const refCode = useRef(localStorage.getItem(REF_CODE))
  // 落在营销站首页：它会收下 refCode，再挂到跳往 fe-user 的登录/注册链接上
  const shareUrl = `https://shaokai-chasing.com/?refCode=${refCode.current}`
  const qrCodeRef = useRef<SVGSVGElement | null>(null)

  return (
    <Container>
      <div className="top">
        <div className="title">Shaokai-Chasing</div>
        <div className="right">
          {refCode.current && (
            <Popover
              trigger="click"
              content={
                <div
                  style={{
                    width: 200,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <QRCodeSVG ref={qrCodeRef} value={shareUrl} />
                  <div style={{ marginTop: 10 }}>
                    <Typography.Link
                      onClick={() => {
                        navigator.clipboard.writeText(shareUrl).then(() => {
                          message.success('复制成功')
                        })
                      }}
                    >
                      复制分享链接
                    </Typography.Link>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <Typography.Link
                      onClick={() => {
                        if (qrCodeRef.current) {
                          svgToPng(qrCodeRef.current)
                        }
                      }}
                    >
                      下载二维码
                    </Typography.Link>
                  </div>
                </div>
              }
            >
              <Button className="button" type="text">
                分享二维码
              </Button>
            </Popover>
          )}
          {!isAdmin() && (
            <Button
              className="button"
              type="text"
              onClick={() => {
                navigate('/home/password')
              }}
            >
              修改登录密码
            </Button>
          )}
          <Button className="button" type="text" onClick={logout}>
            登出
          </Button>
        </div>
      </div>
      <div className="bottom">
        <div className="left">
          <div className="menu">
            <Menu
              defaultOpenKeys={defaultOpenKeys}
              selectedKeys={selectedKeys}
              items={nextMenu}
              mode="inline"
              onClick={onSelect}
            />
          </div>
        </div>
        <div className="right">
          <div className="content">
            <Outlet />
          </div>
          <div className="copyright">
            沪ICP备 xxxx Copyright © 2024 上海韶凯教育科技有限公司
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Index
